import { Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer'
import React from 'react'
import Home from "../../Assets/Images/Home.png"
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';

Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
  });

const styles = StyleSheet.create({
    coverSection: {
        margin: 5,
        padding: 5,
        borderRadius: 5,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Lato', 
    },
    coverTitle: {
        fontSize: 24,
        marginBottom: 20,
        color: "#00577D",
        fontSize: "24px",
        fontWeight: 700,
        lineHeight: "35px",
        fontFamily: 'Lato', 
    },
    coverSubtitle: {
        fontSize: "18px",
        color: "#00577D",
        width: "315px",
        lineHeight : "24px",
        fontFamily: 'Lato', 
        whiteSpace: "nowrap",
    },
    coverImage: {
        width: "378px",
        marginTop: 20,
        height : "378px",
      },
      detailSection :  { 
        width : "200px",
        height : "170px",
        marginTop : 30,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Lato', 
      },
      detailTitle : {
        fontWeight : 700 ,
        fontSize : "14px",
        lineHeight : "17px",
        color : "#245775",
        fontFamily: 'Lato', 
      },
      detailSubtitle : {
        marginTop : 20,
        fontWeight : 400 ,
        fontSize : "14px",
        lineHeight : "17px",
        color : "#245775",
        width : "120px",
        fontFamily: 'Lato', 
      },
      author : {
        marginTop : 30,
        fontWeight : 700 ,
        fontSize : "14px",
        lineHeight : "17px",
        color : "#245775",
        width : "120px",
        fontFamily: 'Lato', 
      }
    
});
const Cover = ({name, apiData}) => {
    return (
        <View style={styles.coverSection}>
            <Text style={styles.coverTitle}>QUADRANT FLOW™</Text>
            <Text style={styles.coverSubtitle}>Aligning the Heart, Soul, Mind & Strength™</Text>
            <Image src={Home}  style={styles.coverImage}/>
            <View style={styles.detailSection}>
            <Text style={styles.detailTitle}>CERTIFIED COACH REPORT
            {name}</Text>
            <Text style={styles.detailSubtitle}>Bruce Wayne Wayne Enterprices 1 Oct 2024</Text>
            <Text style={styles.author}>{apiData?.fullName}</Text>
            </View>
            
        </View>
    )
}

export default Cover